import React, { Fragment } from "react";

import { Row, Col } from "react-bootstrap";

import Dropdown from "../UI/Dropdown/Dropdown";

const vrsteEvidencija = [
  {
    key: 1,
    title: "Police osiguranja",
    value: 1,
  },
  {
    key: 2,
    title: "Izvješća o transparentnosti",
    value: 2,
  },
  {
    key: 3,
    title: "Ugovori o reviziji sa SJI",
    value: 3,
  },
  {
    key: 4,
    title: "Raskidi ugovora sa SJI",
    value: 4,
  },
  {
    key: 5,
    title: "Obavijest iz članka 14. Uredbe (EU) br. 537/2014",
    value: 5,
  },
];

const RecordSection = ({
  currentStep,
  handleRecordChange,
  selectedRecord,
  selectedAction,
}) => {
  const formOptionsVrsteEvidencija = vrsteEvidencija.map((element) => (
    <option key={element.key} value={element.value}>
      {element.title}
    </option>
  ));

  return (
    <Fragment>
      {currentStep == 2 && selectedAction == "unos" && (
        <Row>
          <Col xl={8} lg={10} md={12} className="steps-content">
            <Row className="row justify-content-center">
              <Col xl={6} lg={8} md={12} className="align-self-center">
                <Dropdown
                  hidden
                  onChange={handleRecordChange}
                  value={selectedRecord}
                  id={1}
                  center
                  label={"Odaberite vrstu evidencije"}
                  asProperty="select"
                  map={formOptionsVrsteEvidencija}
                  text="Odaberite vrstu evidencije"
                  className="drop"
                  name="odabirVrsteEvidencije"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </Fragment>
  );
};

export default RecordSection;
